module.exports = __webpack_public_path__ + "img/6-3.d6a34ac0.png";